import { useEffect, useState } from "react";
import Container from "../../Components/Container";
import { PlanCard } from "../../Components/Price/PlanCard";
import { Title, TitleCard } from "../../Components/Price/Price.styles";
import Row from "../../Components/Row";

export default function Price() {
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    async function fetchPlans() {
      try {
        const res = await fetch("https://api-w.meuroom.com.br/signature/plan"); // ajuste para sua rota real
        const data = await res.json();

        // Transformando no formato do PlanCard
        const formatted = data.map((plan: any) => {
          // Pega o ciclo mensal como referência
          const mensal = plan.cicles[0];

          return {
            title: plan.name,
            features: [
              `${mensal?.messages.toLocaleString()} mensagens/mês`,
              plan.description,
            ],
            price: mensal ? mensal.amount.toLocaleString("pt-BR") : "0",
            // Badge opcional: por exemplo, se for o mais caro ou algum outro critério
            badge: plan.name === "Business" ? "Mais popular" : undefined,
            badgeColor: plan.name === "Business" ? "#E49E1B" : undefined,
            badgeTextColor: plan.name === "Business" ? "#000" : undefined,
          };
        });

        setPlans(formatted);
      } catch (err) {
        console.error("Erro ao buscar planos:", err);
      }
    }

    fetchPlans();
  }, []);

  const goToWhatsapp = () => {
    const msg = encodeURIComponent(
      "Olá! Vim pelo site e gostaria de mais mensagens no plano."
    );
    window.open(`https://wa.me/5598984131269?text=${msg}`, "_blank");
  };

  return (
    <Container
      id="section-7"
      style={{ textAlign: "center", backgroundColor: "#000", marginTop: 40 }}
      full
    >
      <Title>
        Planos & <span style={{ color: "#E4DA1B" }}>Preços</span>
      </Title>
      <br />
      <TitleCard $mb={30} style={{ color: "#fff" }}>
        Escolha o plano ideal para o tamanho do seu atendimento.
      </TitleCard>
      <br />
      <Row
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {plans.map((plan: any, i) => (
          <PlanCard key={i} {...plan} />
        ))}
      </Row>
      <br />
      <h5 style={{ color: "#ffffff", fontWeight: 300 }}>
        Precisa de mais mensagens?{" "}
        <span
          onClick={() => {
            goToWhatsapp();
          }}
          style={{ color: "#E4DA1B", textDecoration: "none", cursor: 'pointer' }}
        >
          Fale conosco.
        </span>
      </h5>
    </Container>
  );
}
